export default {"src":"/_next/static/media/logo-madup.1347e181.svg","height":120,"width":194,"blurWidth":0,"blurHeight":0};